import { useState } from 'react';
import { Label, ClassHelper } from 'components/lib';
import Style from './switch.tailwind.js';

export function Switch(props) {
    const controlled = props.checked !== undefined;
    const [on, setOn] = useState(props.default);
    const checked = controlled ? Boolean(props.checked) : on;

    function toggle() {
        const next = !checked;
        if (!controlled) setOn(next);
        props.onChange?.(props.name, next, true);
    }

    const trackStyle = ClassHelper(Style, {
        track: true,
        trackOn: checked,
        trackOff: !checked,
    });

    const handleStyle = ClassHelper(Style, {
        handle: true,
        handleOn: checked,
        handleOff: !checked,
    });

    return (
        <div className={Style.switch}>
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                aria-label={props.label}
                className={trackStyle}
                onClick={toggle}>
                <span className={handleStyle}></span>
            </button>

            <div className={Style.labelWrap}>
                <Label
                    text={props.label}
                    required={props.required}
                    className={Style.label}
                    onClick={toggle}
                />
                {props.hint && <p className={Style.hint}>{props.hint}</p>}
            </div>
        </div>
    );
}
